import React from "react";

const Terms = () => {
  return (
    <div className="terms contento">
      <div className="container">
        <section>
          <h2>Terms and Conditions – Gr8 Appers</h2>
          {/* Effective Date: [Insert Date] */}
          <p className="lgText">
            Welcome to Gr8 Appers! By accessing or using our website and
            services, you agree to be bound by the following terms and
            conditions. Please read them carefully.
          </p>
        </section>

        <section>
          <h4>1. Services Offered</h4>
          <p className="mdText">
            Gr8 Appers provides career counseling, skill assessment, and
            overseas education guidance. All services are provided by qualified
            counselors and educational experts.
          </p>
        </section>

        <section>
          <h4>2. User Responsibility</h4>
          <p className="mdText">
            You agree to provide accurate information during registration or
            while booking services. You are responsible for any activity that
            occurs under your account.
          </p>
        </section>
        <section>
          <h4>3. Service Limitations</h4>
          <p className="mdText">
            We strive to provide accurate advice, but outcomes like admissions,
            scholarships, and visas are not guaranteed and depend on external
            authorities.
          </p>
        </section>
        <section>
          <h4>4. Intellectual Property</h4>
          <p className="mdText">
            All content on this website – including text, graphics, logos, and
            videos – is the property of Gr8 Appers and cannot be copied or used
            without written permission.
          </p>
        </section>
        <section>
          <h4>5. Payments and Refunds</h4>
          <p className="mdText">
            Fees for paid services (like detailed assessments or personalized
            sessions) must be paid in advance. Refunds will be processed only in
            special cases and at the sole discretion of Gr8 Appers.
          </p>
        </section>
        <section>
          <h4>6. Third-Party Links</h4>
          <p className="mdText">
            Our website may contain links to other websites. We are not
            responsible for the content or privacy practices of those websites.
          </p>
        </section>
        <section>
          <h4>7. Modifications</h4>
          <p className="mdText">
            Gr8 Appers reserves the right to modify these terms at any time.
            Continued use of our website after such changes means you accept the
            updated terms.
          </p>
        </section>
        <section>
          <h4>8. Governing Law</h4>
          <p className="mdText">
            These terms are governed by the laws of India. Any disputes will be
            handled by the courts in Hyderabad, Telangana.
          </p>
          <p className="mdText">
            For questions, contact us at{" "}
            <a href="mailto:info@gr8appers.com">info@gr8appers.com</a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default Terms;
